
import Vue from "vue";
import { mapState } from "vuex";

type OssMap = Record<string, string>;

export default Vue.extend({
  data() {
    return {
      row02Image: "icy_silver_switch_pro_v3_02",
      row03Image: "icy_silver_switch_pro_v3_03",
      row04Image: "icy_silver_switch_pro_v3_04",
      row05Image: "icy_silver_switch_pro_v3_05",
      row06Image: "icy_silver_switch_pro_v3_06_01",
      row07Image: "icy_silver_switch_pro_v3_06_02"
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      oss: "oss"
    }),
    // showKv(): boolean {
    //   return this.isCN;
    // },
    kvImageKey(): string {
      // KV 按当前语言切换，中英文各自显示对应视觉稿。
      return this.isCN
        ? this.isMobile
          ? "icy_silver_switch_pro_v3_kv_mobile_cn"
          : "icy_silver_switch_pro_v3_kv_cn"
        : this.isMobile
        ? "icy_silver_switch_pro_v3_kv_mobile_en"
        : "icy_silver_switch_pro_v3_kv_en";
    }
  },
  methods: {
    resolveOssImage(key: string): string {
      return (this.oss as OssMap)[key];
    }
  }
});
